import React, { useCallback } from "react";
import classes from "./search.module.css";
import { useNavigate } from "react-router-dom";

import SearchIcon from "../../img/search-icon.png";
import { useTranslation } from "react-i18next";
const HomePageSearchBtn = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const gotoSearchPage = useCallback(
    () => navigate("/search", { replace: true }),
    [navigate]
  );
  return (
    <div
      onClick={gotoSearchPage}
      className={`w-100 d-flex align-items-center ${classes.homeScreenSearchInput}`}
    >
      <img src={SearchIcon} alt="" width={18} className="d-block" />
      <input
        type="text"
        readOnly="readOnly"
        className="form-control searchinput"
        placeholder={t("Search for Dal")}
      />
    </div>
  );
};
export default React.memo(HomePageSearchBtn);
